export const hasOneOf = <T extends any>(set: Set<T>, values: T[]): boolean => {
	return values.reduce((accumulator, value) => accumulator || set.has(value), false);
};
